import "./ModalImage.css";
import React, { Component } from "react";
import ReactCompareImage from 'react-compare-image';


class ModalImage extends Component {
    handleClose = () => {
        document.body.classList.remove('modal-open');
        this.props.onClose();
    }

    componentDidMount() {
        if (this.props.open) {
            document.body.classList.add('modal-open');
        }
    }
    render() {
        const image = this.props.image === undefined ? null : this.props.image.imageHash;
        const initImage = this.props.image === undefined ? null : this.props.image.initImage;
        return (
            <div className="image-modal" style={{ display: this.props.open ? "block" : "none" }}>
                <div style={{ display: "block" }}>

                    {this.props.mode !== 'scaler' &&
                        <div>
                            <img
                                src={image}
                                alt="GeneratedImage"
                                className="generator-image"
                            />
                        </div>
                    }

                    {this.props.mode === 'scaler' &&
                        <div className="compare-image-container">
                            <ReactCompareImage
                                className="compare-image"
                                leftImage={initImage}
                                rightImage={image}
                                leftImageLabel={"Before"}
                                rightImageLabel={"After"}
                            />;
                        </div>
                    }

                    <button className="button-cancel" onClick={this.handleClose} style={{ diplsay: "block" }}>Close</button>
                </div>
            </div>
        );
    }
}

export default ModalImage;